module.exports = __webpack_public_path__ + "static/media/scb.c2a6774f.svg";